import type { Complaint, ComplaintNew } from "@/views/complaint/complaint";
import { murnAddressFromFormkit, plainMurnAddressFromFormkit } from "@modernary/mui/components/fk";
import { fillAddressLookupValues, fillLookupValuesByPropertyNames } from "@modernary/mui/components/lookup";
import { fixUtcDates } from "@modernary/mui/utils/filters";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};
function addAuthRequestFields(entity: Complaint) {
  entity._authRequestFields = ["id", "statusMurn", "hasInvestigations", "pendingInitialInvestigation"];
  return entity;
}
function getInitialData() {
  const result = {} as Complaint; //TODO: ts
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Complaint }) {
  //TODO - code check and see what can be moved from here to responseAdapater (ideally anything that is not used often)

  addAuthRequestFields(response.data);
  if (!response.data.assignedToObj) response.data.assignedToObj = {};
  if (response.data.assignedTo) {
    response.data.assignedToObj = JSON.parse(response.data.assignedTo);
  }

  if (!response.data.takenByObj) response.data.takenByObj = {};
  if (response.data.takenBy) {
    response.data.takenByObj = JSON.parse(response.data.takenBy);
  }
  if (response.data.scriptValues) {
    response.data.questions = JSON.parse(response.data.scriptValues);
  } else {
    response.data.questions = {};
  }

  await fillAddressLookupValues(response.data);

  await fillLookupValuesByPropertyNames(response.data, ["statusMurn"]);

  if (response.data?.constructionProject) {
    await fillLookupValuesByPropertyNames(response.data, ["crossStreetProximityMurn"]);
  }

  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Complaint }) {
  await skinnyResponseAdapter(response);

  await fillLookupValuesByPropertyNames(response.data, [
    "intakeMethodMurn",
    "programTypeMurn",
    "typeMurn",
    "closedReasonMurn",
    "referredToMurn",
  ]);

  return response.data;
}

function requestAdapter(data: Complaint) {
  data.assignedTo = JSON.stringify(data.assignedToObj) == "{}" ? null : JSON.stringify(data.assignedToObj);
  data.takenBy = JSON.stringify(data.takenByObj) == "{}" ? null : JSON.stringify(data.takenByObj);

  if (data.questions) {
    data.scriptValues = JSON.stringify(data.questions);
  }
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit<T extends Complaint | ComplaintNew>(data: T) {
  //plainMurnAddressToFormkit(data);
  //TODO: Mask Bug phone number only set to be undefined to fix formkit bug. Once formkit resolves bug remove
  if (!data.complainantPhone) {
    data.complainantPhone = undefined;
  }

  //TODO: Mask Bug parcel number only set to be undefined to fix formkit bug. Once formkit resolves bug remove
  if (!data.parcelNumber) {
    data.parcelNumber = undefined;
  }

  // fixUtcDates(data);
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: Complaint) {
  if (data.asbestosFacilityCreate) plainMurnAddressFromFormkit(data.asbestosFacilityCreate);
  if (data.vacantLandParcelCreate) murnAddressFromFormkit(data.vacantLandParcelCreate, "mail");
  //TODO: Mask Bug remove this once the if above is removed.
  if (data.complainantPhone === undefined) {
    data.complainantPhone = null;
  }

  //TODO: Mask Bug remove this once the if above is removed.
  if (data.parcelNumber === undefined) {
    data.parcelNumber = null as any;
  }

  if (data.parcelNumber && !data.parcelNumber.replaceAll("_", "").replaceAll("-", "").trim()) {
    data.parcelNumber = null as any;
  }

  // plainMurnAddressFromFormkit(data as Complaint);
}
